import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import * as getStatus from '~/skills/getStatus';
import { EAA_BottomBtn, EAA_Status, EAA_UpdateTime } from '~/components/EditAndAddItem';
import PageTitle from '~/components/PageTitle';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import Sub1 from './Sub1';
import PierItem from './PierItem';
import Sub3 from './Sub3';

class Page_PierSystem extends Component {
  state={ data: {}, old_data: {}, mode: '', errorAry: [], canSend: true }

  componentDidMount () {
    this.props.getPSPierList();
    this.props.getPSData();
    this.props.getPSRent();
  }

  componentDidUpdate (preProps) {
    const { PSData: prePSData = {} } = preProps;
    const { PSData = {}, mode } = this.props;
    if (Object.keys(prePSData).length === 0 && Object.keys(PSData).length > 0 && (mode !== 'add')) {
      this.setState({ data: PSData, old_data: JSON.parse(JSON.stringify(PSData)) });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('PSData');
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  getSendBody=() => {
    const { data } = this.state;
    const body = {
      sub1: data.sub1 || [],
      // sub2: data.sub2 || [],
      sub3: data.sub3 || [],
      sub4: data.sub4 || [],
      sub5: data.sub5 || [],
      sub6: data.sub6 || [],
      sub7: data.sub7 || [],
      sub8: data.sub8 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewPSData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewPSData(body);
  }

  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { putPSData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putPSData(this.state.data.id, body);
  }

  _onClose=() => {
    const { clearKey, getPSData } = this.props;
    clearKey('PSData');
    getPSData();
    this.setState({ canSend: true, mode: '' });
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      // returnInputValue(data.sign_contract_date) === '', // 0 簽訂行政契約日期
      // (data.sign_upload_files || []).length === 0, // 1 簽訂行政契約函文
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { canEdit } = this.props;
    const { data, old_data, mode, errorAry, canSend } = this.state;
    const isCheck = mode === 'check';
    const disabled = isCheck || !canEdit || (!getStatus.canEdit(data));
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const allRight = errorAry.indexOf(true) === -1;
    const isAdd = Object.keys(old_data).length === 0;

    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='碼頭系統' />
        <Sub1 disabled={disabled} data={data} changeData={this.changeData} checkSubChange={checkSubChange} />
        <PierItem disabled={disabled} data={data} changeData={this.changeData} checkSubChange={checkSubChange} />
        <Sub3 disabled={disabled} data={data} changeData={this.changeData} checkSubChange={checkSubChange} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          disGoBack
          {...{
            data,
            mode: canEdit ? (isAdd ? 'add' : 'edit') : 'view',
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewPSData' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutPSData' />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  PSData: state.data.PSData,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),

  getPSPierList: () => Actions_Wind.getPSPierList(dispatch),
  getPSData: () => Actions_Wind.getPSData(dispatch),
  getPSRent: () => Actions_Wind.getPSRent(dispatch),
  postAddNewPSData: body => Actions_Wind.postAddNewPSData(dispatch, { body }),
  putPSData: (id, body) => Actions_Wind.putPSData(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_PierSystem);
